// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@awc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { color, createLinkIconStyles } from "@awc/XDL/Utilities";
import { addressBookStyles } from "@insite/content-library/Widgets/Addresses/AddressBook";
import Edit from "@insite/mobius/Icons/Edit";
import { css } from "styled-components";

addressBookStyles.addressCard = {
    actionUseAsShippingAddressButton: {
        sizeVariant: "small",
    },
    actionEditLink: {
        ...createLinkIconStyles({
            icon: Edit,
            linkStyles: {
                css: css`
                    display: flex;
                    justify-content: center;
                    margin-top: 12px;
                    margin-left: auto;
                `,
            },
        }),
    },
    gridContainer: {
        gap: 12,
    },
    addressInfoDisplayGridItem: { width: [10, 10, 5, 7, 7] },
    actionsGridItem: {
        width: [2, 2, 7, 5, 5],
        css: css`
            justify-content: flex-end;
        `,
    },
    bottomBorderGridItem: {
        width: 12,
        css: css`
            &&& {
                margin-bottom: 12px;
            }
        `,
    },
    bottomBorder: {
        css: css`
            height: 1px;
            background-color: ${color("common.border")};
            width: 100%;
        `,
    },
};

addressBookStyles.noAddressesText = { ...dataTableStyles.noResultsText };

addressBookStyles.centeringWrapper = {
    css: css`
        height: 300px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};

addressBookStyles.gridContainer = {
    gap: 0,
    css: css`
        margin-top: 16px;
    `,
};

addressBookStyles.addressHeaderGridItem = {
    width: 12,
    css: css`
        border-bottom: 1px solid ${color("common.border")};

        &&&& {
            padding-bottom: 17px;
            margin-bottom: 12px;
        }
    `,
};
